/**
 * Typdefinitioner för Heatmap-vyn
 */

import { Vehicle } from '@/services/vehicles/vehiclesService';

export type HeatmapMode =
  | 'all'
  | 'overspeed'
  | 'idling'
  | 'parking'
  | 'eco'
  | 'timepattern'
  | 'geofence'
  | 'incidents'
  | 'charging'
  | 'riskscore';

export type TimePattern = 'all' | 'morning' | 'day' | 'evening' | 'night';

export interface HeatmapProps {
  sessionId?: string;
  isImport?: boolean;
}

// Mode information for the info modal
export interface ModeInfo {
  titleKey: string;
  descriptionKey: string;
  fallbackTitle: string;
  fallbackDescription: string;
}

export const HEATMAP_MODE_INFO: Record<HeatmapMode, ModeInfo> = {
  all: {
    titleKey: 'heatmap.modeAll',
    descriptionKey: 'heatmap.infoAll',
    fallbackTitle: '',
    fallbackDescription: '',
  },
  overspeed: {
    titleKey: 'heatmap.modeOverspeed',
    descriptionKey: 'heatmap.infoOverspeed',
    fallbackTitle: '',
    fallbackDescription: '',
  },
  idling: {
    titleKey: 'heatmap.modeIdling',
    descriptionKey: 'heatmap.infoIdling',
    fallbackTitle: '',
    fallbackDescription: '',
  },
  parking: {
    titleKey: 'heatmap.modeParking',
    descriptionKey: 'heatmap.infoParking',
    fallbackTitle: '',
    fallbackDescription: '',
  },
  eco: {
    titleKey: 'heatmap.modeEco',
    descriptionKey: 'heatmap.infoEco',
    fallbackTitle: '',
    fallbackDescription: '',
  },
  timepattern: {
    titleKey: 'heatmap.modeTimePattern',
    descriptionKey: 'heatmap.infoTimePattern',
    fallbackTitle: '',
    fallbackDescription: '',
  },
  geofence: {
    titleKey: 'heatmap.modeGeofence',
    descriptionKey: 'heatmap.infoGeofence',
    fallbackTitle: '',
    fallbackDescription: '',
  },
  incidents: {
    titleKey: 'heatmap.modeIncidents',
    descriptionKey: 'heatmap.infoIncidents',
    fallbackTitle: '',
    fallbackDescription: '',
  },
  charging: {
    titleKey: 'heatmap.modeCharging',
    descriptionKey: 'heatmap.infoCharging',
    fallbackTitle: '',
    fallbackDescription: '',
  },
  riskscore: {
    titleKey: 'heatmap.modeRiskScore',
    descriptionKey: 'heatmap.infoRiskScore',
    fallbackTitle: '',
    fallbackDescription: '',
  },
};

// Convert allVehicles to the format expected by SearchableVehicleSelect
export function mapVehicleForSelect(
  vehicle: Vehicle,
  isImport: boolean
): { id: string; registrationNumber: string; brand: string; model: string } {
  return {
    id: isImport ? vehicle.registration_number : vehicle.id?.toString() || '',
    registrationNumber: vehicle.registration_number,
    brand: vehicle.make || '',
    model: vehicle.model || '',
  };
}

// Get default date range (last 7 days)
export function getDefaultDateRange(): { fromDate: string; toDate: string } {
  const toDate = new Date().toISOString().split('T')[0];
  const fromDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0];
  return { fromDate, toDate };
}
